import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import zhHans from 'vuetify/lib/locale/zh-Hans'
import {
  VTreeSelect,
  VCascader,
  VDataGridSelect,
  VmdView,
} from 'vuetify-toolkit/vuetify-toolkit.umd'

Vue.use(Vuetify, {
  VTreeSelect,
  VCascader,
  VDataGridSelect,
  VmdView,
})

const getInitialTheme = () => {
  if (typeof window === 'undefined') return false
  try {
    const stored = window.localStorage.getItem('ui_theme')
    if (stored === 'dark') return true
    if (stored === 'light') return false
  } catch (error) {
    return false
  }
  return (
    window.matchMedia &&
    window.matchMedia('(prefers-color-scheme: dark)').matches
  )
}

const lightTheme = {
  primary: '#0B5C7A',
  secondary: '#1E3A5F',
  accent: '#FF8A3D',
  error: '#E05252',
  info: '#1B74E4',
  success: '#17B897',
  warning: '#F4B740',
  background: '#F4F7FB',
  surface: '#FFFFFF',
  'surface-2': '#F0F4F8',
  'surface-3': '#E7EEF6',
  'on-surface': '#0B1520',
  muted: '#4B5A6A',
}

const darkTheme = {
  primary: '#5CC4E6',
  secondary: '#1F3B4D',
  accent: '#FF9F68',
  error: '#FF6B6B',
  info: '#6FA8FF',
  success: '#44D2B4',
  warning: '#F6C66B',
  background: '#0B1218',
  surface: '#0F1A22',
  'surface-2': '#13202B',
  'surface-3': '#172433',
  'on-surface': '#E6EEF7',
  muted: '#9BAEC2',
}

export default new Vuetify({
  theme: {
    dark: getInitialTheme(),
    options: {
      customProperties: true,
    },
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
  },
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { zhHans },
    current: 'zhHans',
  },
})
